module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/g-authorization-callback/g-authorization-callback.component.css
// module id = ./src/app/g-authorization-callback/g-authorization-callback.component.css
// module chunks = main